module.exports = __webpack_public_path__ + "img/video_player.45d59261.svg";